module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_2.fe793e18eb716c6224ba404031de544d.png";